import { Model } from './model'
import {NestedModel} from "./nestedmodel";
import { SessionId } from "./loginSessions/sessionId";

export class LoginSessions extends Model {
    constructor(attributes) {
        super(Object.assign({}, attributes))
        // TODO: Remove objects that are DELETED
        this._sessionIds = {};
        this.login = new NestedModel({value: 'login', parent: this});
        this.loginWithPrivileges = new NestedModel({value: 'loginWithPrivileges', parent: this});
        this.selfCareLogin = new NestedModel({value: 'selfCareLogin', parent: this});
        this.userAccessRights = new NestedModel({value: 'userAccessRights', parent: this});
        this.selfCareRefresh = new NestedModel({value: 'selfCareRefresh', parent: this});
        this.selfCareLogout = new NestedModel({value: 'selfCareLogout', parent: this});
        this.keepAlive = new NestedModel({value: 'keepAlive', parent: this});
        this.checkSession = new NestedModel({value: 'checkSession', parent: this});
        this.logout = new NestedModel({value: 'logout', parent: this});
    }

    urlRoot() {
        return '/loginSessions';
    }

    url() {
        return this.urlRoot();
    }

    sessionId(value) {
        if (!this._sessionIds[value]) {
            this._sessionIds[value] = new SessionId({value: value, parent: this});
        }
        return this._sessionIds[value];
    }
}
